import { Injectable } from '@angular/core';
import { AlarmAgentApiClient } from './api-client.service';

@Injectable({
	providedIn: 'root',
})
export class ShippingCardService {
	private API_ROUTE = 'admin/shipping';

	constructor(private http: AlarmAgentApiClient) {}

	async getAll(): Promise<ShippingCard[]> {
		return this.get(this.API_ROUTE);
	}

	async getByRsn(start: string, end: string): Promise<ShippingCard[]> {
		return this.get(`${this.API_ROUTE}/rsn/${start}/${end}`);
	}

	async getByCsid(start: string, end: string): Promise<ShippingCard[]> {
		return this.get(`${this.API_ROUTE}/csid/${start}/${end}`);
	}

	private async get(route: string): Promise<ShippingCard[]> {
		return this.http.get(route).toPromise();
	}
}

export class ShippingCard {
	customerServiceId?: string;
	importWord?: string;
	serialNumber?: string;
}
